<template>
  <div>
    <el-dialog
      class="KNS-dialog"
      :visible.sync="dialogActiveShow"
      width="70%"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div
        slot="title"
        class="top-wrap"
      >
        <i
          class="icon-close"
          aria-hidden="true"
          @click="closeDialiogBtn('active')"
        />
        <h1 class="title">
          此感應載具已開通過<span class="sumCom">{{ tabledList.length }}</span>戶
        </h1>
        <p class="subtitle">
          若繼續開通，可能會造成包裹誤領，請再次與住戶確認是否繼續開通！
        </p>
        <i
          class="icon-warning bgicon"
          aria-hidden="true"
        />
      </div>
      <div class="main-area">
        <h3>詳細戶別資訊如下：</h3>
        <div class="tabletnote">
          <span
            v-for="(tabletNote,tabletNote_ind) in tabledList"
            :key="tabletNote_ind"
          >「{{ tabletNote }}」</span>
        </div>
        <span class="remind">※為避免發生爭議，請住戶用手機開通，確保權益受到保障</span>
      </div>
      <div slot="footer">
        <el-button @click="cancel">
          取消開通
        </el-button>
        <el-button
          type="primary"
          @click="determine"
        >
          確認開通
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="KNS-dialog receive"
      :visible.sync="dialogReceiveShow"
      width="70%"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div
        slot="title"
        class="top-wrap"
      >
        <i
          class="icon-close"
          aria-hidden="true"
          @click="closeDialiogBtn('receive')"
        />
        <h1 class="title">
          此載具同時開通了<span class="sumCom">{{ tabledList.length }}</span>個戶別
        </h1>
        <p class="subtitle">
          為避免造成物品誤領，請先與住戶確認要領取的戶別，再繼續領取。
        </p>
        <i
          class="icon-warning bgicon"
          aria-hidden="true"
        />
      </div>
      <div class="main-area">
        <h3>以下為重覆開通的戶別：</h3>
        <div class="tabletnote">
          <el-table
            class="KNSDialogTable"
            :data="tabledList"
            border
            style="width: 100%"
            @selection-change="receiveSel"
          >
            <el-table-column
              prop="date"
              type="selection"
              width="300"
            />
            <el-table-column
              prop="tabletNote"
              label="戶別"
            />
          </el-table>
        </div>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          @click="receiveSubmit"
        >
          送出
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogActiveShow: false,
      dialogReceiveShow: false,
      tabledList: [],
      receiveSelList: [],
      callBackFunction: null
    }
  },
  methods: {
    alert (info, cbf, model = 'active') {
      // eslint-disable-next-line eqeqeq
      if (model == 'active') {
        this.dialogActiveShow = true
        JSON.parse(info.list).map(val => this.tabledList.push(val.tabletNote))
        this.callBackFunction = cbf
      // eslint-disable-next-line eqeqeq
      } else if (model == 'receive') {
        console.log(info)
        this.tabledList = info
        this.dialogReceiveShow = true
        this.callBackFunction = cbf
      }
    },
    determine () { // 確認開通
      this.callBackFunction(true)
      this.dialogActiveShow = false
      this.tabledList = []
      this.callBackFunction = null
    },
    cancel () { // 取消開通
      this.callBackFunction(false)
      this.dialogActiveShow = false
      this.tabledList = []
      this.callBackFunction = null
    },
    closeDialiogBtn (model) {
      console.log(model)
      // eslint-disable-next-line eqeqeq
      if (model == 'receive') {
        this.receiveSubmit()
      // eslint-disable-next-line eqeqeq
      } else if (model == 'active') {
        this.cancel()
      }
    },
    receiveSel (val) {
      this.receiveSelList = val
    },
    receiveSubmit () {
      this.callBackFunction(this.receiveSelList)
      this.dialogReceiveShow = false
      this.tabledList = []
      this.receiveSelList = []
      this.callBackFunction = null
    }
  }
}
</script>

<style lang="sass" scoped>
  ::v-deep .el-dialog
    margin-top: 12vh !important
  ::v-deep .el-dialog__footer
    border-top: 1px solid #e5e5e5
    padding: 20px 15px
  ::v-deep .el-dialog__body
    padding: 0
  ::v-deep .el-dialog__header
    padding: 100px 50px
    background-color: $RepeatedOpeningColor
    position: relative
    overflow: hidden
    .icon-close
      color: #fff
      font-size: 20px
      z-index: 2000
    .top-wrap
      text-align: left
      i
        position: absolute
        top: 10px
        right: 10px
        cursor: pointer
      .title
        color: #fff
        margin: 0 0 10px
        font-weight: 800
        font-size: 36px
        .sumCom
          font-weight: 600
          padding: 0 5px
          font-size: 50px
      .subtitle
        color: #fff
        font-size: 20px
      .bgicon
        position: absolute
        right: -10px
        top: -65px
        opacity: 0.1
        font-size: 350px
        color: #fff
  .main-area
    padding: 20px 50px 15px
    font-size: 20px
    color: #2f2f2f
    h3
      font-size: 20px
      margin: 15px 0 10px 0
      font-weight: 500
    .tabletnote
      height: 100px
      border: 1px solid #e0e0e0
      overflow-y: scroll
      padding: 5px 10px
      text-align: left
    .remind
      font-size: 17px
      margin-top: 15px
      display: block
      color: #ed8d05
  .receive
    ::v-deep .el-dialog__body
      padding: 20px 50px 0
    .main-area
      padding: 0
      .tabletnote
        height: 240px
        padding: 0
        border: 0
  .KNSDialogTable
    ::v-deep .el-table
      +KNSDialogTable
      &__header
        th
          font-size: 16px
          background-color: #ecefee
          color: #000
          ::v-deep .el-checkbox__inner
            width: 20px
            height: 20px
            &:after
              left: 50%
              top: 50%
              height: 10px
              width: 3px
              transform: translate(-50%,-50%) rotate(45deg) scaleY(1)
              border-width: 2px
            &:before
              height: 4px
              top: 8px
      &__body
        tr
          > td
            font-size: 17px
            text-align: center
            color: #2f2f2f
            .el-checkbox__inner
              width: 20px
              height: 20px
              &:after
                left: 50%
                top: 50%
                height: 10px
                width: 3px
                transform: translate(-50%,-50%) rotate(45deg) scaleY(1)
                border-width: 2px
</style>
